export const TRANSCRIBE_LANGUAGE_CODE = "en-US";

export const TRANSCRIBE_MEDIA_ENCODING = "pcm";

export const TARGET_SAMPLE_RATE = 16000;
export const BUFFER_SIZE = 4096;

export const SILENCE_THRESHOLD = 0.01;
export const SILENCE_TIMEOUT_MS = 2500;

export const DUPLICATE_TRANSCRIPT_WINDOW_MS = 1500;

export const MIC_ERROR_MESSAGE_MAP = {
  NotAllowedError:
    "Microphone access was denied. Please allow access and try again.",
  NotFoundError: "No microphone was found on this device.",
  NotReadableError:
    "Microphone is already in use or unavailable. Please try again.",
  AbortError: "Microphone access was interrupted. Please try again.",
  default: "Unable to access microphone. Please try again.",
};
